import React from 'react';

const ConfirmModal = ({ 
    open, 
    title = 'Confirm', 
    message = 'Are you sure?', 
    onConfirm, 
    onCancel, 
    confirmText = 'OK', 
    cancelText = 'Cancel',
    confirmButtonStyle = 'danger', // 'danger', 'success', 'primary'
    isLoading = false
}) => {
    if (!open) return null;
    
    const getConfirmButtonClasses = () => {
        switch (confirmButtonStyle) {
            case 'success':
                return 'btn-primary bg-green-600 hover:bg-green-700';
            case 'primary':
                return 'btn-primary';
            case 'danger':
            default:
                return 'btn-primary bg-red-600 hover:bg-red-700';
        }
    };
    
    return (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4" onClick={onCancel}>
            <div className="bg-white dark:bg-secondary-800 rounded-2xl shadow-xl p-5 sm:p-6 w-full max-w-sm mx-4 relative border border-secondary-200 dark:border-secondary-700 max-h-[90vh] max-h-[90dvh] overflow-y-auto" onClick={e => e.stopPropagation()}>
                <div className="text-lg font-semibold mb-4 dark:text-white">{title}</div>
                <div className="mb-6 dark:text-secondary-300 break-words">{message}</div>
                <div className="flex flex-col-reverse sm:flex-row justify-end gap-3">
                    <button
                        className="btn-secondary min-h-[44px] w-full sm:w-auto"
                        onClick={onCancel}
                    >
                        {cancelText}
                    </button>
                    <button
                        className={`${getConfirmButtonClasses()} min-h-[44px] w-full sm:w-auto ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                        onClick={onConfirm}
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <div className="flex items-center justify-center gap-2">
                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                                Loading...
                            </div>
                        ) : (
                            confirmText
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal; 